import { call, takeEvery, takeLatest } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { TaasNachlassVorteilRequest } from '@ps20/bff-models';
import {
  GlobalActions,
  GlobalPut,
  GlobalEventDispatcher,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { PS20Logger } from '@ps20-frontend/logging';
import { NachlaesseForAngebot } from '@ps20/bff-models/dist/lib/ps20-bff-model-taas';
import { ToolbarAction, ToolbarActions } from '../toolbar.actions';

export enum RABATT_REQUEST_EVENTS {
  RABATT_REQUEST_SUCCESSFUL = 'RABATT_REQUEST_SUCCESSFUL',
  RABATT_REQUEST_FAILED = 'RABATT_REQUEST_FAILED',
}

export function* watchRabattServiceRequest() {
  yield takeLatest(ToolbarActions.RABATT_SERVICE, safeSaga(rabattServiceSaga, App.SHOP_TOOLBAR));
  yield takeEvery(
    RABATT_REQUEST_EVENTS.RABATT_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_TOOLBAR),
  );
  yield takeEvery(
    RABATT_REQUEST_EVENTS.RABATT_REQUEST_FAILED,
    safeSaga(errorCallback, App.SHOP_TOOLBAR),
  );
}

export function* rabattServiceSaga(action: ToolbarAction<Array<TaasNachlassVorteilRequest>>) {
  const globalPut = GlobalPut.getInstance();
  const urlRabattService = '/privatschutz/api/rabatte/berechnen';
  const requestAction = new GlobalActions().doRequest({
    appId: App.SHOP,
    body: action.payload,
    url: urlRabattService,
    successEvent: RABATT_REQUEST_EVENTS.RABATT_REQUEST_SUCCESSFUL,
    errorEvent: RABATT_REQUEST_EVENTS.RABATT_REQUEST_FAILED,
    noCache: true,
  });
  yield call(globalPut.put, requestAction);
}

export function successCallback(successAction: AnyAction) {
  const rabattServiceResponse: Array<NachlaesseForAngebot> = successAction.payload;
  GlobalEventDispatcher.getInstance().dispatch(
    new ToolbarActions().rabattServiceNachlaesseReceived(rabattServiceResponse),
  );
  GlobalEventDispatcher.getInstance().dispatch(
    new ToolbarActions().initRabattServiceNachlaesse(rabattServiceResponse),
  );
}

export function errorCallback(errorAction: AnyAction) {
  PS20Logger.error(App.SHOP, 'Nachlassrabatt-Service fail!', errorAction.payload?.toString());
}
